export type InsightKey =
  | "totalViews"
  | "totalClicks"
  | "totalSaves"
  | "avgCTR"
  | "hotDeals"
  | "departmentEngagement"
  | "topPerformingDeals";

export type AnalyticsFilters = {
  merchantId?: string;
  storeId?: string;
  categoryId?: string;
  dateFrom?: string;
  dateTo?: string;
};

export const DEFAULT_ANALYTICS_FILTERS: AnalyticsFilters = {
  dateFrom: "-30d",
};

export type PostHogInsightResponse = {
  results?: unknown;
  columns?: string[];
  hasMore?: boolean;
  result?: unknown;
  [key: string]: unknown;
};

export type AnalyticsDashboardResults = Partial<
  Record<InsightKey, PostHogInsightResponse>
>;

export type AnalyticsCatalogItem = {
  key: InsightKey;
  label: string;
  description?: string;
  defaultDateRange?: { date_from?: string };
};

export type AnalyticsItemMetadata = {
  item_name?: string | null;
  item_image_src?: string | null;
};

export type AnalyticsInsightMetadata = {
  items?: Record<string, AnalyticsItemMetadata>;
};

export type ParsedItemCell = {
  id: string;
  name: string;
  imageSrc?: string | null;
};

export type ParsedTable = {
  headers: string[];
  rows: string[][];
  /** Per-row item metadata for the first column when the API provides it. */
  itemMetaByRow?: Array<ParsedItemCell | null>;
};

export type ParsedBarPoint = {
  label: string;
  value: number;
};
